import { put, takeLeading } from "redux-saga/effects";
import { post } from "sagas/helpers/network";
import $ from "jquery";

function* exexute(action: sage.actions.team.IUpdateTeam) {
    const response = yield post("/update-team", {
        team_id: action.teamId,
        name: action.name,
    });
    if (response != null) {
        yield put({
            type: "com.sage.actions.teams.ISetTeam",
            team: response.data,
        } as sage.actions.team.ISetTeam);
    }
    ($("#changeTeamNameModal") as any).modal("hide");
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.team.IUpdateTeam", exexute);
}
